import React, { SetStateAction, useEffect, useState } from "react";
import {
  Box,
  Typography,
  Checkbox,
  FormControlLabel,
  Button,
  Paper,
  FormGroup,
} from "@mui/material";
import DescriptionIcon from "@mui/icons-material/Description";
import LanguageIcon from "@mui/icons-material/Language";
import { KnowledgeBase, KnowledgeBaseCombine } from "../../../Shared-ui/Types/KnowledgeBase";
import { KNOWLEDGE, KNOWLEDGE_BASE } from "../../../Services/Endpoint";
import { useDispatch } from "react-redux";
import { StartLoading, StopLoading } from "../../../Shared-ui/Store/LoadingReducer/LoaderActions";
import BaseInstance from "../../../Services/AxiosInstance/BaseInstance";
import { ShowError } from "../../../Shared-ui/Store/MessageReducer/MsgActions";
import EmptyStateImage from "../../../assets/images/Agents_emptystateimage.svg"
import variables from "../../../assets/styles/variables.module.scss";
import Tooltip from '@mui/material/Tooltip';




interface MyComponentProps {
  setKnowledgeBaseCombine: React.Dispatch<SetStateAction<KnowledgeBaseCombine>>
  knowledgeBaseCombine: KnowledgeBaseCombine
  knowledgeBase: KnowledgeBase
  onSwitchToDocumentTab?: (tabIndex: number) => void;
}




const CombinedTab: React.FC<MyComponentProps> = (props) => {
  const dispatch = useDispatch()
  const [knowledgeBases, setKnowledgeBases] = useState<KnowledgeBase[]>([])
  const [selectedKBs, setSelectedKBs] = useState<number[]>([]);



  useEffect(() => {
    getKnowledgeBases()
  }, [])

  useEffect(() => {
    if (props.knowledgeBase.id) {
      getCombinedKnowledgeBasesIds()
    }
  }, [props.knowledgeBase.id])


  const getCombinedKnowledgeBasesIds = async () => {
    try {
      dispatch(StartLoading());
      const data = await BaseInstance.get(`${KNOWLEDGE}/combined/${props.knowledgeBase.id}`).then(
        (res) => res?.data
      );
      props.setKnowledgeBaseCombine(() => {
        return { source_knowledge_base_ids: data.source_knowledge_base_ids };
      });
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.statusText));
    } finally {
      dispatch(StopLoading());

    }

  }

  const getKnowledgeBases = async () => {
    try {
      dispatch(StartLoading());
      const data = await BaseInstance.get(`${KNOWLEDGE_BASE}`).then(
        (res) => res?.data
      );
      data.items?.sort((a: { name: string }, b: { name: string }) => a.name.localeCompare(b.name));
      setKnowledgeBases(data.items?.filter((kw: KnowledgeBase) => kw.id != props.knowledgeBase.id))
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.statusText));
    } finally {
      dispatch(StopLoading());

    }

  }


  const handleSelectKB = (event: any, knowledgeId: string) => {
    const name = event.target.name
    const checked = event.target.checked
    props.setKnowledgeBaseCombine(preVal => {
      if (checked) {
        return { source_knowledge_base_ids: [...preVal.source_knowledge_base_ids, knowledgeId] }
      } else {
        const updatedIds = preVal.source_knowledge_base_ids?.filter(id => id != knowledgeId)
        return { source_knowledge_base_ids: updatedIds }
      }

    })
  };



  return (
    <Box sx={{ textAlign: "center" }}>
      {knowledgeBases.length === 0 ? (
        <Box sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          mt: 6,
        }}>
          <Tooltip title="No knowledge base found" arrow>
            <img
              src={EmptyStateImage}
              alt="No Knowledge Bases"
              style={{ width: 120, height: "auto" }}
            />
          </Tooltip>
          <Typography variant="h6"
            sx={{
              mt: 2,
              cursor: "pointer",
              textDecoration: "underline",
              color: variables.basicColor
            }}
            onClick={() => props.onSwitchToDocumentTab && props.onSwitchToDocumentTab(0)}
          >
            Click here to Create Knowledge
          </Typography>
        </Box>
      ) : (
        <>
          <Box sx={{ textAlign: "left" }}>
            <Typography variant="body1" sx={{ fontWeight: "bold", mb: 2 }}>
              Select Knowledge to Combine
            </Typography>
          </Box>

          <FormGroup
            sx={{
              maxHeight: "222px",
              overflowY: "auto",
              flexWrap: "nowrap",
            }}
          >
            {knowledgeBases.map((knowledgeBase) => (
              <Box>
                {knowledgeBase.id && (
                  <Paper
                    key={knowledgeBase.id}
                    variant="outlined"
                    sx={{ display: "flex", alignItems: "center", mb: 1.5 }}
                  >
                    <Checkbox
                      checked={props.knowledgeBaseCombine.source_knowledge_base_ids.includes(knowledgeBase.id)}
                      onChange={(event) => knowledgeBase.id && handleSelectKB(event, knowledgeBase.id)}
                    />
                    {knowledgeBase.type === "pdf" ? (
                      <DescriptionIcon sx={{ color: "#E65100" }} />
                    ) : (
                      <LanguageIcon sx={{ color: "#1E88E5" }} />
                    )}
                    <Typography sx={{ ml: 1 }}>{knowledgeBase.name}</Typography>
                  </Paper>
                )}
              </Box>

            ))}
          </FormGroup>
        </>)}
    </Box>
  );
};

export default CombinedTab;
